import React, { useState, useEffect } from 'react';
import axios from 'axios'
import * as $ from 'jquery';
import 'bootstrap'
import Select from 'react-select';
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import moment from 'moment';
import html2pdf from 'html2pdf.js';


export default function Addsearch(props) {
    const [items, setitems] = useState({ bookingdate: "", bookingdatefwd: "", bookingdateback: "", UnitId:"" });
    const [data, setdata] = useState([]);
    const [addunit, setunit] = useState([]);
    const [unitvalue, setunitvalue] = useState();
    const [unitError, setUnitError] = useState();
    const [showBtn, setShowPdfBtn] = useState(false);
    const showHide = ()=>{
       setShowPdfBtn(true);
    }
    useEffect(() => {
        fetchUnitdata()
    }, [])
    async function fetchUnitdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }
    const setunitvalues = (e) => {

    }
    const onChangeDate = e => {
        debugger;
        const newDate = moment(new Date(e.target.value)).format('YYYY-MM-DD');
        const onefwd = moment(newDate, 'YYYY-MM-DD').add('days', 1).format('YYYY-MM-DD');
        const oneback = moment(newDate, 'YYYY-MM-DD').subtract('days', 1).format('YYYY-MM-DD');
        setitems({ ...items, bookingdate: newDate, bookingdatefwd: onefwd, bookingdateback: oneback })
        fetcheveintdata(newDate, onefwd, oneback)
    };
    async function fetcheveintdata(newDatea, onefwda, onebacka) {
        debugger;
        const url = process.env.REACT_APP_APIURL + "Booking/bydatebooking?companyid=" + props.companyid + "&dt=" + newDatea + "&db=" + onebacka + "&dn=" + onefwda;
        let Unitdata = await axios.get(url);
        await setdata(Unitdata.data);
    }
    // date range /
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);

    const handleDateChange = ({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
    };
    const getSelectedDateRangeCount = () => {
        debugger;
        if (startDate && endDate) {
            return endDate.diff(startDate, 'days') + 1;
        }
        return 0;
    };
    const handleSubmit1 = async (e) => {
        e.preventDefault();
        if (!items.UnitId) {
            setUnitError(true);
            return;
        }
        debugger;
        var data = {}
        data.UnitId = items.UnitId
        data.startDate = moment(new Date(startDate)).format('YYYY-MM-DD');
        data.endDate = moment(new Date(endDate)).format('YYYY-MM-DD');
        const url = process.env.REACT_APP_APIURL + "Booking/bydateunitbooking?companyid=" + props.companyid + "&sdt=" + data.startDate + "&edt=" + data.endDate + "&unitid=" + data.UnitId;
        let Unitdata = await axios.get(url);
        await setdata(Unitdata.data);
        
    }
    const prinReport = (e) => {
        e.preventDefault();
        let printEleme = document.getElementById('reportPrint');

        // Define margins for mobile and desktop
        let marginForMobile = [11.5, 0, 30, 0]; 
        let marginForDesktop = [10, 0, 16, 0];
        let screenWidth = window.innerWidth;
        let isDesktop = screenWidth > 575; 
        let margins = isDesktop ? marginForDesktop : marginForMobile;
        var opt = {
            margin: margins,
            filename:'Booking Report',
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 2,
                bottom: 50,
                
            },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
            jsPDF: {
                unit: 'mm',
                orientation: 'portrait'
            }
        };
        setTimeout(() => {
            html2pdf().set(opt).from(printEleme).then(function () {
                $("#inner").css({ "font-size": "12px", "background-color": "#F5F5F5" });
            }).save();
        }, 300);
    }
    return (
        <>

            <div className="row">
                <div className="col-12">
                    <div className="card" id="reportPrint">
                        <div className="card-header">
                            <h4 className="me-auto mb-0">By Date</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit1}>
                            <div className='row' data-html2canvas-ignore="true">
                                <div className="mb-3 col-10 col-sm-6 col-md-6 col-lg-4">
                                    <label className="form-label">Select Farm</label>
                                    <Select
                                        name="unit"
                                        value={unitvalue}
                                        options={addunit}
                                        onChange={(e) => {
                                            setunitvalues(e);
                                            setitems({ ...items, UnitId: e.value });
                                            setUnitError(false);
                                        }}
                                        required
                                    />
                                    {unitError && <div className="error-message">Farm selection is required</div>}
                                </div>
                               
                                {/* dateRangePicker */}

                                <div className="mb-3 col-10 col-sm-6 col-md-6 col-lg-4">
                                    <label className="form-label">Date</label>
                                    <div className="search-inp">
                                    
                                    <DateRangePicker
                                    startDate={startDate}
                                    startDateId="start_date_id"
                                    endDate={endDate}
                                    endDateId="end_date_id"
                                    onDatesChange={handleDateChange}
                                    focusedInput={focusedInput}
                                    onFocusChange={(focusedInput) =>
                                        setFocusedInput(focusedInput)
                                    }
                                    isOutsideRange={() => false}
                                    numberOfMonths={1}
                                            displayFormat="DD/MM/YYYY"
                                            required />
                                        </div>
                                </div>
                                {/* dateRangePicker */}

                                <div className="col-10 col-sm-6 col-md-6 col-lg-4 d-flex align-items-center mt-3">
                                        <button type="submit" className="btn btn-primary" id="book" onClick={showHide}>Search</button>
                                </div>
                                </div>
                            </form>
                            {/* From section */}
                            <div className="col-12">
                                {/* farm booking */}
                                <div className="shift-colors by-form-shift by_color">
                                    <ul>
                                        <li className={showBtn === true?'download_pdf':'download_pdf hidepdf_btn'} onClick={prinReport} data-html2canvas-ignore="true" ><span className='fa-file-pdf'></span>Download</li>
                                        <li><span className='a_booking'></span>Available</li>
                                        <li><span className='b_booking'></span>Booked</li>
                                    </ul>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: data }} />
                            </div>
                        </div>
                        {/* card body */}
                    </div>
                </div>
            </div>
        </>
    );
}
